// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var RoiType;
(function (RoiType) {
    RoiType["MISSED_CALL_TEXT"] = "MISSED_CALL_TEXT";
    RoiType["APPOINTMENT_REMINDERS"] = "APPOINTMENT_REMINDERS";
    RoiType["MARKETING_MESSAGE"] = "MARKETING_MESSAGE";
})(RoiType || (RoiType = {}));
export var RoiType_index;
(function (RoiType_index) {
    RoiType_index[RoiType_index["MISSED_CALL_TEXT"] = 0] = "MISSED_CALL_TEXT";
    RoiType_index[RoiType_index["APPOINTMENT_REMINDERS"] = 1] = "APPOINTMENT_REMINDERS";
    RoiType_index[RoiType_index["MARKETING_MESSAGE"] = 2] = "MARKETING_MESSAGE";
})(RoiType_index || (RoiType_index = {}));
export var AttributeType;
(function (AttributeType) {
    AttributeType["FUTURE_APPOINTMENTS"] = "FUTURE_APPOINTMENTS";
    AttributeType["CONVERTED_PATIENTS"] = "CONVERTED_PATIENTS";
    AttributeType["RAW_SMS"] = "RAW_SMS";
    AttributeType["FORWARD"] = "FORWARD";
    AttributeType["BACKWARD"] = "BACKWARD";
})(AttributeType || (AttributeType = {}));
export var AttributeType_index;
(function (AttributeType_index) {
    AttributeType_index[AttributeType_index["FUTURE_APPOINTMENTS"] = 0] = "FUTURE_APPOINTMENTS";
    AttributeType_index[AttributeType_index["CONVERTED_PATIENTS"] = 1] = "CONVERTED_PATIENTS";
    AttributeType_index[AttributeType_index["RAW_SMS"] = 2] = "RAW_SMS";
    AttributeType_index[AttributeType_index["FORWARD"] = 3] = "FORWARD";
    AttributeType_index[AttributeType_index["BACKWARD"] = 4] = "BACKWARD";
})(AttributeType_index || (AttributeType_index = {}));
export var ViewType;
(function (ViewType) {
    ViewType["DAY_VIEW"] = "DAY_VIEW";
    ViewType["WEEKLY_VIEW"] = "WEEKLY_VIEW";
    ViewType["MONTHLY_VIEW"] = "MONTHLY_VIEW";
    ViewType["SEVEN_DAYS_VIEW"] = "SEVEN_DAYS_VIEW";
})(ViewType || (ViewType = {}));
export var ViewType_index;
(function (ViewType_index) {
    ViewType_index[ViewType_index["DAY_VIEW"] = 0] = "DAY_VIEW";
    ViewType_index[ViewType_index["WEEKLY_VIEW"] = 1] = "WEEKLY_VIEW";
    ViewType_index[ViewType_index["MONTHLY_VIEW"] = 2] = "MONTHLY_VIEW";
    ViewType_index[ViewType_index["SEVEN_DAYS_VIEW"] = 3] = "SEVEN_DAYS_VIEW";
})(ViewType_index || (ViewType_index = {}));
export var AppointmentStatusRequired;
(function (AppointmentStatusRequired) {
    AppointmentStatusRequired["APPOINTMENT_CONFIRMED"] = "APPOINTMENT_CONFIRMED";
    AppointmentStatusRequired["APPOINTMENT_COMPLETED"] = "APPOINTMENT_COMPLETED";
})(AppointmentStatusRequired || (AppointmentStatusRequired = {}));
export var AppointmentStatusRequired_index;
(function (AppointmentStatusRequired_index) {
    AppointmentStatusRequired_index[AppointmentStatusRequired_index["APPOINTMENT_CONFIRMED"] = 0] = "APPOINTMENT_CONFIRMED";
    AppointmentStatusRequired_index[AppointmentStatusRequired_index["APPOINTMENT_COMPLETED"] = 1] = "APPOINTMENT_COMPLETED";
})(AppointmentStatusRequired_index || (AppointmentStatusRequired_index = {}));
export var ContactType;
(function (ContactType) {
    ContactType["UNSHEDULED_PATIENT"] = "UNSHEDULED_PATIENT";
    ContactType["NEW_PATIENT"] = "NEW_PATIENT";
    ContactType["EXISTING_PATIENT"] = "EXISTING_PATIENT";
})(ContactType || (ContactType = {}));
export var ContactType_index;
(function (ContactType_index) {
    ContactType_index[ContactType_index["UNSHEDULED_PATIENT"] = 0] = "UNSHEDULED_PATIENT";
    ContactType_index[ContactType_index["NEW_PATIENT"] = 1] = "NEW_PATIENT";
    ContactType_index[ContactType_index["EXISTING_PATIENT"] = 2] = "EXISTING_PATIENT";
})(ContactType_index || (ContactType_index = {}));
export const AnalyticsGatewayService = {
    ListSiblingsAdminRoles(fn, req) {
        try {
            fm.validateUrlParam(req["userId"], "userId");
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/disabled/users/${req["userId"]}/siblingsadmin/${req["locationId"]}?${fm.renderURLSearchParams(req, ["userId", "locationId"])}`, { method: "GET" });
    },
    ListSiblingsAdminRolesForSlug(fn, req) {
        try {
            fm.validateUrlParam(req["userId"], "userId");
            fm.validateUrlParam(req["slugId"], "slugId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/disabled/users/${req["userId"]}/siblingsadminbyslug/${req["slugId"]}?${fm.renderURLSearchParams(req, ["userId", "slugId"])}`, { method: "GET" });
    },
    GetScheduleConversion(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/getscheduleconversion`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetRoiAggregates(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/aggregates`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetRoiSMS(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
            fm.validateUrlParam(req["attributeType"], "attributeType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/sms/${req["attributeType"]}`, { method: "POST", body: JSON.stringify(req["smsRequest"], fm.replacer) });
    },
    GetRoiTimelineView(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
            fm.validateUrlParam(req["attributeType"], "attributeType");
            fm.validateUrlParam(req["viewType"], "viewType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/timeline/${req["attributeType"]}/${req["viewType"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetRoiChartView(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
            fm.validateUrlParam(req["attributeType"], "attributeType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/chartview/${req["attributeType"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetNoShowRateAggregates(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/getnoshowrate/aggregated`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetROIAggregatesV2(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/aggregatesV2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetNoShowRate(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/getnoshowrate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetTrendline(fn, req) {
        try {
            fm.validateUrlParam(req["roiType"], "roiType");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/analytics-reporting/analytics_gateway/roi/${req["roiType"]}/gettrendliine`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
